import React, {useEffect, useRef, useState} from 'react';
import Divider from '../Divider';
import {GridCardComponent} from './grid-card.component';
import {Slots} from '../../slots';
import {useNavigate} from 'react-router';

const CardsPage: React.FC = () => {
    const navigate = useNavigate();
    const [centeredIndex, setCenteredIndex] = useState<number | null>(null);
    const cardRefs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const index = Number(entry.target.getAttribute('data-index'));
                    if (entry.isIntersecting) {
                        setCenteredIndex(index);
                    }
                });
            },
            {
                root: null,
                threshold: 0.9, // Adjusted for mobile
            }
        );

        cardRefs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            cardRefs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    return (
        <section className="min-h-screen w-screen relative">
            <Divider/>
            <h1 className="mt-5 text-8xl md:text-9xl pt-3 font-bold text-center max-w-6xl m-auto font-boldonse text-transparent bg-clip-text bg-gradient-to-l from-pink-200 to-pink-400 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)]">
                Portfolio
            </h1>

            <div
                className="p-4 sm:p-6 md:p-10 mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-1 md:gap-3">
                {Slots.map((prop, index) => (
                    <div
                        key={index}
                        ref={(el) => (cardRefs.current[index] = el) as any}
                        data-index={index}
                        className={'hover:cursor-pointer'}
                        onClick={() => navigate(`/slot/${prop.id}`)}
                    >
                        <GridCardComponent prop={prop} isInCenter={centeredIndex === index} />
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CardsPage;
